import MainContext from 'context/MainContext';
import { useContext } from 'react';

const useModalTestPlayer = () => {
    const {
        modalTestPlayerOpen,
        modalTestPlayerSource,
        setModalTestPlayerOpen,
        setModalTestPlayerSource
    } = useContext(MainContext)


    const open = (playerSource = null) => {
        setModalTestPlayerOpen(true)
        if (playerSource) {
            setModalTestPlayerSource(playerSource)
        }
    }

    const close = () => {
        setModalTestPlayerOpen(false)
        setModalTestPlayerSource()
    }

    return {
        modalTestPlayerOpen: modalTestPlayerOpen,
        modalTestPlayerSource: modalTestPlayerSource,
        openTestPlayer: (playerSource) => open(playerSource),
        closeTestPlater: (playerSource) => close(playerSource),
        setModalTestPlayerSource: (playerSource) => setModalTestPlayerSource(playerSource)
    };
}

export default useModalTestPlayer